__turbopack_context__.v({
  "btn": "CarouselV2-module-scss-module__RvtNCG__btn",
  "btn-next": "CarouselV2-module-scss-module__RvtNCG__btn-next",
  "btn-prev": "CarouselV2-module-scss-module__RvtNCG__btn-prev",
  "progress": "CarouselV2-module-scss-module__RvtNCG__progress",
  "progress-first": "CarouselV2-module-scss-module__RvtNCG__progress-first",
  "progress-second": "CarouselV2-module-scss-module__RvtNCG__progress-second",
  "slide": "CarouselV2-module-scss-module__RvtNCG__slide",
  "track": "CarouselV2-module-scss-module__RvtNCG__track",
  "viewport": "CarouselV2-module-scss-module__RvtNCG__viewport",
  "wrapper": "CarouselV2-module-scss-module__RvtNCG__wrapper",
});
